import { useState } from 'react';

const testimonials = [
  {
    name: 'Jennifer M.',
    role: 'Home Buyer',
    location: 'Newtown, PA',
    text: 'Black Dog Settlement made our first home purchase completely stress-free. They explained every step of the closing process and were incredibly responsive. We closed on time without a single hiccup. Highly recommend to anyone in Bucks County.',
    rating: 5,
  },
  {
    name: 'Robert & Lisa T.',
    role: 'Home Sellers',
    location: 'Doylestown, PA',
    text: "We've used several title companies over the years and Black Dog Settlement is by far the best. Their attention to detail on the title search caught an old lien we didn't even know about. Saved us from a major headache.",
    rating: 5,
  },
  {
    name: 'David K.',
    role: 'Real Estate Agent',
    location: 'Montgomery County',
    text: 'As a realtor, I need a settlement company I can trust to keep my deals on track. Black Dog Settlement is my go-to for all my Bucks and Montgomery County transactions. Professional, fast, and always communicative.',
    rating: 5,
  },
  {
    name: 'Sarah P.',
    role: 'Home Buyer',
    location: 'West Chester, PA',
    text: 'The team at Black Dog Settlement was fantastic throughout our Chester County home purchase. They were patient with all our questions and made sure we understood everything before signing. Truly a pleasure to work with.',
    rating: 5,
  },
];

const TestimonialsSection = () => {
  const [active, setActive] = useState(0);

  return (
    <section className="bg-[#f7f5f0] py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left */}
          <div className="w-full lg:w-[38%] lg:sticky lg:top-24">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-[#c9a84c]"></div>
              <span className="text-[#c9a84c] text-xs font-bold tracking-[0.3em] uppercase">Client Reviews</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-[#0f0f0f] leading-tight mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Trusted by<br />Pennsylvania<br />Homeowners
            </h2>
            <div className="flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActive(i)}
                  className={`transition-all duration-300 cursor-pointer rounded-full ${
                    i === active ? 'w-10 h-2 bg-[#c9a84c]' : 'w-2 h-2 bg-stone-300 hover:bg-stone-400'
                  }`}
                  aria-label={`Review ${i + 1}`}
                />
              ))}
            </div>
          </div>

          {/* Right - testimonial cards */}
          <div className="w-full lg:w-[62%] space-y-4">
            {testimonials.map((t, i) => (
              <div
                key={t.name}
                onClick={() => setActive(i)}
                className={`p-8 border transition-all duration-300 cursor-pointer ${
                  i === active
                    ? 'bg-[#0f0f0f] border-[#0f0f0f]'
                    : 'bg-white border-stone-200 hover:border-stone-300'
                }`}
              >
                <div className="flex items-start justify-between gap-4 mb-4">
                  <div>
                    <p className={`font-bold text-sm ${i === active ? 'text-white' : 'text-[#0f0f0f]'}`}>{t.name}</p>
                    <p className={`text-xs mt-0.5 ${i === active ? 'text-white/40' : 'text-stone-400'}`}>{t.role} — {t.location}</p>
                  </div>
                  <div className="flex gap-0.5 shrink-0">
                    {Array.from({ length: t.rating }).map((_, j) => (
                      <div key={j} className="w-3 h-3 flex items-center justify-center">
                        <i className={`ri-star-fill text-xs ${i === active ? 'text-[#c9a84c]' : 'text-amber-400'}`}></i>
                      </div>
                    ))}
                  </div>
                </div>
                <p className={`text-sm leading-relaxed ${i === active ? 'text-white/60' : 'text-stone-500'}`}>
                  "{t.text}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
